<template>
  <TabView :tabs="tabList"></TabView>
</template>

<script setup>
import TabView from '@/components/TabView.vue'
import ShipCardsView from '@/components/ShipCardsView.vue'
import { useConstantStore } from '@/stores/constant'
import { useUserStore } from '@/stores/user'

const constantStore = useConstantStore()
const userStore = useUserStore()

const tabList = []

for (const [category, _] of Object.entries(constantStore.cardCategories)) {
  tabList.push({
    label: constantStore.getCategoryName(category, userStore.languageCode),
    category: category,
    component: ShipCardsView,
  })
}
</script>

<style></style>
